// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "7e306e60bbfc61a2d11b9e7751933e3230a617ac/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};